import firebase from "firebase/app";
import 'firebase/auth';
import 'firebase/firestore';

// Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  var firebaseConfig = {
    apiKey: "AIzaSyBNRnepYmZpFTocNRUvFl4XW3ZRi0kcI8c",
    authDomain: "psych-apps.firebaseapp.com",
    databaseURL: "https://psych-apps.firebaseio.com",
    projectId: "psych-apps",
    storageBucket: "psych-apps.appspot.com",
    messagingSenderId: "511723236563",
    appId: "1:511723236563:web:793557c47da772e129f826",
    measurementId: "G-P8NT4RPK7Y"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  //firebase.analytics();

  // Exports
  export const auth = firebase.auth();
  export const firestore = firebase.firestore();

  // Manage Google sign-in
  const provider = new firebase.auth.GoogleAuthProvider();
  provider.setCustomParameters({prompt: 'select_account'});
  export const signInWithGoogle = () => auth.signInWithPopup(provider);

export default firebase;